import { showToast } from './helpers/show-toast';

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text).then(() => {
    showToast({
      title: 'Copied!',
      description: `"${text}" has been copied to clipboard.`,
      variant: 'info',
    });
  });
};
